/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetPaymentRequestsBankAccountsList200ResponseInnerTransferFeeCondition } from './get-payment-requests-bank-accounts-list200-response-inner-transfer-fee-condition';

/**
 * BankAccount with TransferFeeCondition
 * @export
 * @interface GetPaymentRequestsBankAccountsList200ResponseInner
 */
export interface GetPaymentRequestsBankAccountsList200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestsBankAccountsList200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestsBankAccountsList200ResponseInner
     */
    'recordId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestsBankAccountsList200ResponseInner
     */
    'bankNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestsBankAccountsList200ResponseInner
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestsBankAccountsList200ResponseInner
     */
    'branchNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestsBankAccountsList200ResponseInner
     */
    'branchName': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestsBankAccountsList200ResponseInner
     */
    'accountType': GetPaymentRequestsBankAccountsList200ResponseInnerAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestsBankAccountsList200ResponseInner
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestsBankAccountsList200ResponseInner
     */
    'companyCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestsBankAccountsList200ResponseInner
     */
    'companyName': string;
    /**
     * 
     * @type {GetPaymentRequestsBankAccountsList200ResponseInnerTransferFeeCondition}
     * @memberof GetPaymentRequestsBankAccountsList200ResponseInner
     */
    'transferFeeCondition': GetPaymentRequestsBankAccountsList200ResponseInnerTransferFeeCondition;
}

export const GetPaymentRequestsBankAccountsList200ResponseInnerAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    other: 'OTHER'
} as const;

export type GetPaymentRequestsBankAccountsList200ResponseInnerAccountTypeEnum = typeof GetPaymentRequestsBankAccountsList200ResponseInnerAccountTypeEnum[keyof typeof GetPaymentRequestsBankAccountsList200ResponseInnerAccountTypeEnum];


